<mat-list>
  @if (listItems?.length) {
  <mat-divider></mat-divider>
  } @for (listItem of listItems; track listItem) {
  <mat-list-item>
    <img matListItemAvatar [src]="listItem.logoSrc" alt="avatar" />
    <div matListItemTitle>
      {{ listItem.heading }} @if (listItem.verified) {
      <mat-icon class="verified" svgIcon="verified"></mat-icon>
      }
    </div>
    <div matListItemLine>{{ listItem.h2 }}</div>
    <div matListItemLine>{{ listItem.h3 }}</div>
  </mat-list-item>
  <mat-divider></mat-divider>
  }
</mat-list>
